<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAuthStore } from './store/auth'
import { useThemeStore } from './store/theme'
import { useDashboardStore } from './store/dashboard'
import { socketService } from './services/api'
import { useToast } from 'vue-toastification'

const authStore = useAuthStore()
const themeStore = useThemeStore()
const dashboardStore = useDashboardStore()
const toast = useToast()

onMounted(() => {
  // Initialize theme
  themeStore.initTheme()
  
  // Initialize auth state
  authStore.initializeAuth()
  
  // Initialize socket if authenticated
  if (authStore.isAuthenticated) {
    socketService.connect()
    dashboardStore.initSocketListeners()
  }
  
  // Show welcome toast
  if (authStore.isAuthenticated) {
    toast.success('Welcome back!', {
      timeout: 3000
    })
  }
})

// watch for auth changes to connect/disconnect socket
watch(() => authStore.isAuthenticated, (isAuth) => {
  if (isAuth) {
    socketService.connect()
    dashboardStore.initSocketListeners()
  } else {
    socketService.disconnect()
  }
})
</script>

<style>
/* Custom animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Smooth transitions */
* {
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

/* Focus styles */
.focus-ring {
  @apply focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2;
}

/* Responsive utilities */
@media (max-width: 768px) {
  .mobile-hidden {
    display: none;
  }
}

@media (min-width: 769px) {
  .desktop-hidden {
    display: none;
  }
}
</style>
